import styled from 'styled-components';
import { palette } from '@dev/ee-components';


export const FormPageDropdownWrapper = styled.div`
    margin-top: 16px;

     .Mui-disabled {
        svg path {
            fill: ${palette.gray[4]};
        }
    }
`;
export const FormPageDropdownSectionWrapper = styled.div`
    margin-bottom: 32px;
`;